import {Component, OnInit} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';
import {RestService} from '../providers/rest.service';
import {Router} from '@angular/router';
import {Page} from '../model/page';
import {TalepOnaySeviye} from '../model/talep-onay-seviye';

@Component({
  selector: 'app-talep-onay-seviyeler',
  templateUrl: './talep-onay-seviyeler.component.html',
  styleUrls: ['./talep-onay-seviyeler.component.css']
})
export class TalepOnaySeviyelerComponent implements OnInit {
  talepOnaySeviyeler: TalepOnaySeviye[] = null;

  constructor(private helperProvider: HelperProvider,
              private restService: RestService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.TalepOnayTurleri);
    this.getTalepOnaySeviyeler();
  }

  getTalepOnaySeviyeler() {
    this.restService.talepOnaySeviyeler().subscribe(res => {
      if (res != null) {
        this.talepOnaySeviyeler = res;
      }
    });
  }

  kaldir(s: any) {
    if (confirm(`Silmek istediğinize emin misiniz?`)) {
      this.restService.talepOnaySeviyeSil(s.id).subscribe(res => {
          this.getTalepOnaySeviyeler();
      });
    }
  }

  incele(s: any) {
    this.router.navigate(['talep-onay-seviye'], {queryParams: {id: s.id}});
  }

  new() {
    this.router.navigate(['talep-onay-seviye'], {queryParams: {id: '0'}});
  }
}
